
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/account/login",
      function () {
        return require("private-next-pages/customer/account/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/account/login"])
      });
    }
  